import React from 'react'
import PropTypes from 'prop-types'
import HeadingAlpha from '../headings/heading-alpha'
import HistoryList from '../lists/history-list'

const BidHistory = ({ bidItems }) => (
  <div className='modal-main'>
    <HeadingAlpha className='bottom-space'>Bid History</HeadingAlpha>
    {bidItems && bidItems.length ? (
      <HistoryList
        items={[
          {
            amount: 'Amount',
            time: 'Time',
            date: 'Date',
            className: 'list-header'
          },
          ...bidItems
        ]}
      />
    ) : (
      <p>No bids.</p>
    )}
  </div>
)

BidHistory.propTypes = {
  bidItems: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.string,
      time: PropTypes.string,
      date: PropTypes.string
    })
  )
}

export default BidHistory



// WEBPACK FOOTER //
// ./src/ui/views/bid-history.js